import { render, staticRenderFns } from "./statementList.vue?vue&type=template&id=65cf033b&scoped=true&"
import script from "./statementList.vue?vue&type=script&lang=js&"
export * from "./statementList.vue?vue&type=script&lang=js&"
import style0 from "./statementList.vue?vue&type=style&index=0&id=65cf033b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf033b",
  null
  
)

export default component.exports